export class SemanaTypes {

  id?: any;
  tienda?:string;
  fecha?:string;
  ventasSem?:number = 0;
  tIdDb?:string = "";
  mPorcentaje?:MallaPorcentajeTypes;
  estado?:any;
}

export class MallaPorcentajeTypes{
  dias?:DiaTypes[] = [];
  estado?:number = 0;
}

export class DiaTypes {

  porcentaje?:number;
  horas?:HoraTypes[] = [];
  precio?:number;
  txtDia?:string;
  fecha?:string;
}

export class HoraTypes {

  txtHora?:string;
  porcentaje?:number;
  precio?:number;
}
